export function getNextId(initialId: string): string {
  return `${initialId}-${Date.now()}-${Math.random().toString().slice(2)}`;
}
